import { render } from "./HealthSyncToggle.vue?vue&type=template&id=e3c511da&scoped=true"
import script from "./HealthSyncToggle.vue?vue&type=script&lang=js"
export * from "./HealthSyncToggle.vue?vue&type=script&lang=js"

import "./HealthSyncToggle.vue?vue&type=style&index=0&id=e3c511da&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c511da"]])

export default __exports__